/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Duration_Out_Of_Bounds_HintInputs */

const en_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase/decrease the duration of the Event.`)
};

const fr_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmentez/reduisez la duree de l'evenement.`)
};

const de_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dauer des Ereignisses erhöhen/verkürzen.`)
};

const it_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta/diminuisci la durata dell'evento.`)
};

const ru_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить/уменьшить продолжительность мероприятия.`)
};

const es_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar/disminuir la duración del Evento.`)
};

const zh_cn2_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增加/减少事件持续时间。`)
};

const ja_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの継続時間を増加/減少します。`)
};

const hi_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की अवधि बढ़ाएँ/घटाएँ।`)
};

const pt_pt2_error_nav_duration_out_of_bounds_hint = /** @type {(inputs: Error_Nav_Duration_Out_Of_Bounds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar/diminuir a duração do evento.`)
};

/**
* | output |
* | --- |
* | "Increase/decrease the duration of the Event." |
*
* @param {Error_Nav_Duration_Out_Of_Bounds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_duration_out_of_bounds_hint = /** @type {((inputs?: Error_Nav_Duration_Out_Of_Bounds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Duration_Out_Of_Bounds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "de") return de_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "it") return it_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "ru") return ru_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "es") return es_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "ja") return ja_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "hi") return hi_error_nav_duration_out_of_bounds_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_duration_out_of_bounds_hint(inputs)
	return en_error_nav_duration_out_of_bounds_hint(inputs)
});